import { Component, OnInit, Input } from '@angular/core';
import { CommandsService } from '../services/commands.service';
import { LanguageService } from '../services/language.service';
import { CanvasService } from '../services/canvas.service';
import { EditorContentService } from '../services/editorcontent.service';
import { TurtleService } from '../services/turtle.service';

import { AppComponent } from './app.component';
import { CanvasComponent } from './canvas.component';
import { InputComponent } from './input.component';
import { SessionStorageService } from '../services/sessionstorage.service';
import { BlocksService } from '../services/blocks.service';

declare var require: (...any) => any;
declare var Blockly: any;

@Component({
  selector: 'app-blocks',
  host: {
    '(document:keyup)': 'keyup($event)'
  },
  templateUrl: './blocks.component.html',
  providers: [LanguageService, EditorContentService, CommandsService, TurtleService, CanvasService, SessionStorageService, BlocksService]
})

export class BlocksComponent implements OnInit {

	@Input('languageServiceMaster') lang: LanguageService;
	@Input('commandsServiceMaster') commandsService: CommandsService;
	@Input('turtleServiceMaster') turtleService: CommandsService;
	@Input('canvasServiceMaster') canvasService: CanvasService;
	@Input('editorContentServiceMaster') et: EditorContentService;
  @Input('sessionstorageMaster') sessionstorage: SessionStorageService;
  @Input('blocksServiceMaster') blocks: BlocksService;

  //Logging
  static LOGGING = false;
  static STORAGELOCATION = "digitaltag";

  //UI buttons for starting, clearing the screen and resetting
  private startBlocksButton = 'app/img/blockIcons/xlogo/event_whenflagclicked.svg';
  private clearWorkspaceButton = 'app/img/blockIcons/xlogo/remove.svg';
  private clearScreenButton = 'app/img/blockIcons/xlogo/cs_2.png';

  constructor() {

    // Close the dropdown if the user clicks outside of it
    window.onclick = function (event: MouseEvent) {
      // check whether dropdown menu was clicked or something else
      let el = <Element>event.target;
      let selector = '.headerbtn';
      let p = Element.prototype;
      let f = p.matches || p.webkitMatchesSelector || p.msMatchesSelector || function (s) {
        return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
      };

      // check whether dropdown menu was clicked or not
      let a = f.call(el, selector);

      // if it was not clicked, then close the dropdown menu
      if (!a) {
        let dropdowns = document.getElementsByClassName('dropdown-content');
        let i;
        for (i = 0; i < dropdowns.length; i++) {
          let openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    };

  }

  startBlockExecution() {
    // read from the Blockly elements
    var [command,xml] = this.blocks.readBlocks();

    if (command !== '') {
      InputComponent.inputComponent.executeCommand(command, "", false);
      if(this.blocks.isClearScreenBeforeExec() || this.blocks.isHistoryGray()){
        this.blocks.clearHistory();
      }
      this.blocks.copyExecBlocksToHistory(xml);
    }
  }

  clearWorkspace() {
    this.clearScreen();
    this.blocks.clearWorkspace();
  }

  clearScreen() {
    InputComponent.inputComponent.executeCommand("cs", "", false);
    // clear history on next execution
    this.blocks.setHistoryGray();
  }

  // stop working, called when user interrupts computation, in case it takes too long
  stop() {
    CanvasComponent.stop = true;
  }

  // hide the main dropdown menu
  untoggle() {
    let dropdowns = document.getElementsByClassName('dropdown-content');
    let i;
    for (i = 0; i < dropdowns.length; i++) {
      let openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }

  // check if arrow up or arrowdown are pressed
  keyup(event: KeyboardEvent) {
    // refresh workspace (displayed parameters) on enter also update command on enter
    if (this.blocks.isBlockMode()) {

      // on 'Enter'-key
      if (event.keyCode === 13) {
/*         // execution on Enter disabled since it doesn't work without implicit clearscreen (cs)
        var text = this.blocks.readBlocks();
        InputComponent.inputComponent.executeCommand(this.blocks.getCommand(), "", false);

        // workaround because Input-fields visually don't update after change
        if (!this.blocks.isClearScreenBeforeExec()){
          this.blocks.clearWorkspace();
          this.blocks.constructHistory(text);
        }
 */
        this.blocks.rerenderWorkspace();
      }

    }
  }




  ngOnInit() {

    // choose Toolbox for Blocks (BlueBot or Advanced)
    if (this.blocks.getMode() == 1) {
      var toolbox = this.blocks.getBlueBotToolbox(); // variant 1
    } else if (this.blocks.getMode() == 2) {
      var toolbox = this.blocks.getVariant2Toolbox(); // variant 2
    }

    // change visual appearance according to blockmode
    if (!this.blocks.isBlockMode()) {
      return;
    }

    // don't display Debugging-Switch when in BlockMode
    this.et.hideDebugFunctionality();
    // switch app container to flex-bow with flex-direction = column
    let container = document.getElementById('container');
    container.classList.add('containerBlocks');
    container.classList.remove('container');
    // unhide block buttons in header
    let startButton = document.getElementById('startExec');
    startButton.classList.remove('hidden');
    let clearWorkspace = document.getElementById('clearWorkspace');
    clearWorkspace.classList.remove('hidden');
    let csButton = document.getElementById('clearScreen');
    csButton.classList.remove('hidden');

    // setup blockly
    this.blocks.setWorkspace(Blockly.inject('blocklyDiv', {toolbox: toolbox, horizontalLayout: true, media: 'app/img/blockIcons/', scrollbars: false, comments: false}));

    // generate start Flag
    this.blocks.clearWorkspace();
    this.blocks.addHistorytoExecCopyButton();

    // Event listeners for workaround to issue #1329 (https://github.com/LLK/scratch-blocks/issues/1329)
    // because Input-Field visually doesn't upadte after change
    let clickInputField = function (event) {
      if(event.type == Blockly.Events.BLOCK_CHANGE && event.element == 'field') {
        this.blocks.getWorkspace().addChangeListener(allEvents);
        this.blocks.saveWorkspace();
      }
    }.bind(this);

    let allEvents = function (event) {
      if(event.type != Blockly.Events.BLOCK_CHANGE) {
        this.blocks.getWorkspace().removeChangeListener(allEvents);
        this.blocks.loadWorkspace();

      }
    }.bind(this);

    this.blocks.getWorkspace().addChangeListener(clickInputField);

  }

}



// WEBPACK FOOTER //
// ./src/app/components/blocks.component.ts